var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RosterManagement',{attrs:{"routePlantID":_vm.plantID,"routeProductCategoryID":_vm.productCategoryID}})}
var staticRenderFns = []

export { render, staticRenderFns }